<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户分组信息</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search" style="align-items: center;">
             <div><el-button type="warning" size="small"
                    @click.native="dialogAddData = true">新增分组</el-button></div>
            <div style="margin-left: 20px;">
                <el-input placeholder="请输入分组名" prefix-icon="el-icon-search" size="small"
                    v-model="group_name" @keyup.enter.native="Query"></el-input>
            </div>
            <div style="margin-left: 20px;"> <el-button type="primary" size="small" @click.native="Query">查询</el-button>
            </div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div>
           
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="allGrouping" style="width: 100%" size="mini" stripe :row-class-name="tableRowClassName">
                <el-table-column prop="id" label="分组id" width="100"></el-table-column>
                <el-table-column prop="name" label="用户分组名" width="300"></el-table-column>
                <el-table-column prop="description" label="用户分组描述" width="280"></el-table-column>
                <el-table-column prop="created_at" label="用户分组创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="235">
                    <template slot-scope="scope">
                        <el-button type="success" @click="clickLook(scope.$index, scope.row)">分组用户</el-button>
                        <!-- <el-button type="info" @click="clickGroupTasks(scope.$index, scope.row)">分组任务</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="添加数据" :visible.sync="dialogAddData" width="80%" top="6vh" center @close="closeDialogAdd">
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="用户组名" :label-width="formLabelWidth" prop="group_name">
                    <el-input v-model="addData.group_name" autocomplete="off" placeholder="请输入用户组名"></el-input>
                </el-form-item>
                <el-form-item label="分组描述" :label-width="formLabelWidth" prop="description">
                    <el-input v-model="addData.description" autocomplete="off" placeholder="请输入分组描述"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            formLabelWidth: '150px',
            pages: 1,
            limit: 10,
            deBugList: [],
            total: 0,
            dateValue: '',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            deBugCondition: '',
            allGrouping: [],
            dialogAddData: false,
            addData: {
                group_name: '',
                description: ''
            },
            rules: {
                group_name: [
                    { required: true, message: '用户组名为必填项', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: '分组描述为必填项', trigger: 'blur' }
                ],
            },
            group_name: ''
        }
    },
    created() {
        this.getAllGrouping()
    },
    methods: {
        getAllGrouping() {
            this.$get(`/v1/admin/groups?group_name=${this.group_name}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.allGrouping = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        addAllGrouping(apiData) {
            console.log(apiData)
            this.$post(`/v1/admin/groups`, apiData).then((res) => {
                if (res.data.status === 'success') {
                    this.dialogAddData = false
                    this.addData = {
                        group_name: '',
                        description: ''
                    }
                    this.getAllGrouping()
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getDeBugList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getDeBugList()
        },
        handleDateChange(value) {
            // 用户选择日期后触发的方法
            const year = value.getFullYear();
            const month = value.getMonth() + 1; // 月份是从0开始的，所以需要加1
            const day = value.getDate();
            const selectedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
            this.dateValue = selectedDate
            console.log(this.dateValue)
        },
        Query() {
            this.getAllGrouping(); // 使用选择的日期发起请求
        },
        resetting() {
            this.group_name = ''
            this.getAllGrouping()
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        closeDialogAdd() {
            this.dialogAddData = false
            this.addData = {
                group_name: '',
                description: ''
            }
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.addAllGrouping(this.addData)
                } else {
                    this.$message.error('请输入内容!')
                    return false;
                }
            });
        },
        clickLook(index, row) {
            console.log(index, row)
            this.$router.push({
                path: '/user_grouping_details',
                query: {
                    group_id: row.id,
                    fullscreen:'true',
                    group_name: row.name
                }
            });
            // this.$get(`/v1/admin/groups/list-group-members?group_id=${row.id}`, {}).then((res) => {
            //     if (res.data.status === 'success') {
            //         console.log(res.data.data, '0000000000000000')
            //     } else {
            //         this.$msg(res.data.msg)
            //     }
            // });
        },
        clickGroupTasks(index, row) {
            console.log(index, row)
            this.$router.push({
                path: '/groupTasks',
                query: {
                    group_id: row.id,
                }
            });
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 220px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>
<style scoped>
.custom-content {
    display: -webkit-box;
    /* 作为弹性盒子模型显示 */
    -webkit-box-orient: vertical;
    /* 设置弹性盒子主轴方向为垂直 */
    overflow: hidden;
    /* 隐藏超出内容 */
    text-overflow: ellipsis;
    /* 在内容超出时显示省略号（但此属性在此场景下可能不直接生效，由-webkit-line-clamp处理） */
    max-height: 100px;
    /* 设置最大高度，与行数限制共同决定最终显示效果 */
    line-height: normal;
}
</style>


// WEBPACK FOOTER //
// src/pages/user_grouping/user_grouping.vue